import React from "react";
import Modal from "../modal/modal";
import {useAppContext} from "../../context/AppContext";

const ModalRetryError = ({
                             retryCallBack = () => {
                             }
                         }) => {
    const {changeItem} = useAppContext();
    const retry = () => {
        changeItem({error: false, ErrorComponent: null});
        setTimeout(retryCallBack, 200);
    };
    return (
        <Modal
            title={"Lo sentimos"}
            Description={
                "Te invitamos a inténtarlo nuevamente para que puedas continuar con tu solicitud."
            }
            buttonLabel={"Reintentar"}
            action={retry}
        />
    );
};

export default ModalRetryError;
